<template>
  <div>
    <v-btn @click.stop="drawer = !drawer" class="ml-4 mr-0" icon>
      <v-badge :content="news" color="green" overlap v-if="news > 0">
        <v-icon color="white">mdi-bell-outline</v-icon>
      </v-badge>
      <v-icon color="white" v-else>mdi-bell-outline</v-icon>
    </v-btn>

    <portal to="drawer-de-notificacao">
      <v-navigation-drawer
        v-model="drawer"
        :width="425"
        absolute
        temporary
        right
        style="height: 100vh"
        light
      >
        <v-toolbar color="rgb(4, 35, 51)" dark>
          <v-toolbar-title>Notificações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="drawer = !drawer" class="ml-4 mr-0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list
          two-line
          style="max-height: calc(-64px + 100vh); overflow-y: auto"
        >
          <template v-if="itens.length > 0">
            <template v-for="(item, index) in itens">
              <v-list-item :key="item.title" class="ma-0">
                <v-list-item-content @click="selected(item)">
                  <v-list-item-title
                    class="text-uppercase"
                    :class="
                      item.lida_at ? 'font-weight-regular' : 'font-weight-black'
                    "
                    v-text="item.usuario"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    class="text-uppercase caption"
                    :class="item.meta && item.meta.class ? item.meta.class : ''"
                    v-text="item.titulo"
                  ></v-list-item-subtitle>

                  <v-list-item-subtitle
                    class="text-uppercase caption"
                    v-text="item.descricao"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="mt-1 mr-0">
                  <v-menu>
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-btn v-bind="attrs" v-on="{ ...menu }" icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="arquivar(item)">
                        <v-list-item-icon class="mr-4">
                          <v-icon>mdi-archive</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Arquivar </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="lida(item)">
                        <v-list-item-icon class="mr-4">
                          <v-icon
                            v-text="
                              item.lida_at
                                ? 'mdi-email-mark-as-unread'
                                : 'mdi-email-open'
                            "
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="
                              item.lida_at
                                ? 'Marcar como não lida'
                                : 'Marcar como lida'
                            "
                            >>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-list-item-action-text>
                    {{ item.created_at | fromNow }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < itens.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </template>
          <template v-else>
            <v-list-item disabled>
              <v-list-item-content>
                <v-list-item-title class="text-center">
                  Não há dados disponíveis
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <notificacao />
      </v-navigation-drawer>
    </portal>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment-timezone";
import notificacao from "@/components/notificacao/Dialog";
import io from "socket.io-client";

moment.locale("pt-br");
moment.tz.setDefault("America/Manaus");

export default {
  components: { notificacao },
  data() {
    return {
      socket:
        window.__APP_CONFIG__.VUE_APP_NOTIFICATION == "true"
          ? io(window.__APP_CONFIG__.VUE_APP_NOTIFICATION_URL)
          : io(""),
      sound: require("@/assets/notification.mp3"),
      drawer: null,
      menu: false,
    };
  },
  computed: {
    ...mapGetters("notificacao", ["itens", "news"]),
  },
  created() {
    this.$store.dispatch("notificacao/Itens");
  },
  mounted() {
    this.socket.on("rMessage", (data) => {
      let usuario_id = localStorage.getItem("id");
      if (usuario_id == data.to_id) {
        this.$store.dispatch("notificacao/Itens");
        this.$store.dispatch("wkfAutorizacao/Itens", {});
        var audio = new Audio(this.sound);
        audio.play();
      }
    });
  },
  methods: {
    ...mapMutations("app", ["setDialogAutorizacao"]),
    ...mapMutations("notificacao", ["setDialog"]),
    selected(prop) {
      this.$store.dispatch("notificacao/Update", {
        id: prop.id,
        lida_at: moment(),
      });

      if (prop.meta && prop.meta.autorizacao) {
        this.$store.dispatch("wkfAutorizacao/Itens", {
          tipo: {
            id: "APR",
            label: "APROVAR",
            title: "",
          },
        });
        this.setDialogAutorizacao(true);
      } else if (prop.meta && prop.meta.autorizacao_retorno) {
        this.$store.commit("notificacao/setItem", prop);
        this.setDialog(true);
      } else {
        this.$store.commit("notificacao/setItem", prop);
        this.setDialog(true);
      }
    },
    lida(prop) {
      this.$store.dispatch("notificacao/Update", {
        id: prop.id,
        lida_at: prop.lida_at ? "" : moment(),
      });
    },
    arquivar(prop) {
      this.$store.dispatch("notificacao/Update", {
        id: prop.id,
        arquivada_at: moment(),
      });
    },
  },
  filters: {
    fromNow: (v) => {
      if (!v) return "";
      return moment(v, "DD/MM/YYYY HH:mm:ss").fromNow();
    },
  },
};
</script>
